import { render, staticRenderFns } from "./StrategyGridCpt.vue?vue&type=template&id=3972252d&scoped=true&"
import script from "./StrategyGridCpt.vue?vue&type=script&lang=ts&"
export * from "./StrategyGridCpt.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyGridCpt.vue?vue&type=style&index=0&id=3972252d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972252d",
  null
  
)

export default component.exports